import { ConfigReportComboApi } from "go-report-combo/User/services/types";

export const REPORT_organization_with_not_potential_kpi = {
	id: "REPORT_organization_with_not_potential_kpi",
	name: "Funkcje aktywne - nieużywane - według zepołów",
	data: [
		{
			id: "ORGANIZATION",
			resource: "ORGANIZATION",
			filter: "partner_type|e={partner_type}çfeature_potential_count|lt=1",
			groups: ["NONE", "NAME"],
			columns: [
				{
					id: "summary",
					filter: "first_paid_at|bt={date_range__QUARTER}",
				},
				{
					id: "monthly",
					group: "FIRST_PAID_AT_MONTH",
					filter: "first_paid_at|bt={date_range__QUARTER}",
				},
			],
		},
	],
	table: [
		{
			id: "ORGANIZATION",
			rows: [
				{
					id: "ORGANIZATION",
					name: "Nieustawiony potencjał",
					data_id: "ORGANIZATION",
					group: "NAME",
					aggregate_columns: {
						count: "count",
						count_monthly: "count",
					},
				},
			],
			columns: [
				{
					id: "count",
					data_column_id: "summary",
					name: "Aktywne",
				},
				{
					id: "count_monthly",
					data_column_id: "monthly",
					name: "Aktywne",
					values_dynamic: "values_previous_3_months¥{date_range__QUARTER}",
				},
			],
		},
	],
} as ConfigReportComboApi;
